import { classNames } from '@/utils/classNames';

import styles from '@/styles/common.module.css';

type ProgressBarProps = {
  value: number;
  className?: string;
  label?: string;
};

export function ProgressBar({ value, className, label }: ProgressBarProps): JSX.Element {
  const boundedValue = Math.min(100, Math.max(0, value));

  return (
    <div
      className={classNames(styles.progress, className)}
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={100}
      aria-valuenow={Math.round(boundedValue)}
      aria-label={label}
    >
      <div className={styles.progressFill} style={{ width: `${boundedValue}%` }} />
    </div>
  );
}
